document.addEventListener('DOMContentLoaded', function () {
  // Watch for dynamic elements being added
  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return; // Only element nodes

        /**
         * START
         * Fix: ARIA role should be appropriate for the element
         * Page: All
         * Accessibility Tool: AXEDEV
         */
        const chatButtonIframe = node.querySelector('iframe#chat-button');
        if (chatButtonIframe) {
          chatButtonIframe.removeAttribute('role');
          chatButtonIframe.removeAttribute('aria-live');
        }
        /**
         * END
         * Fix: ARIA role should be appropriate for the element
         * Page: All
         * Accessibility Tool: AXEDEV
         */

        /**
         * START
         * Fix: Images must have alternative text
         * Page: Product view
         * Accessibility Tool: AXEDEV
         */
        const tag = node.tagName.toLowerCase();
        if (tag === 'img') {
          if (node.classList.contains('xse-image')) {
            node.setAttribute('alt', 'Main product view');
          } else if (node.classList.contains('xse-image-alt')) {
            node.setAttribute('alt', 'Alternate product view');
          }
        }

        // Fix image alt if images are nested inside added node
        const imgs = node.querySelectorAll?.('img.xse-image, img.xse-image-alt');
        imgs?.forEach((img) => {
          if (img.classList.contains('xse-image')) {
            img.setAttribute('alt', 'Main product view');
          } else if (img.classList.contains('xse-image-alt')) {
            img.setAttribute('alt', 'Alternate product view');
          }
        });
        /**
         * END
         * Fix: Images must have alternative text
         * Page: Product view
         * Accessibility Tool: AXEDEV
         */

        /**
         * START
         * Fix1: <ul> and <ol> must only directly contain <li>, <script> or <template> elements
         * Fix2: <li> elements must be contained in a <ul> or <ol>
         * Page: Product view
         * Accessibility Tool: AXEDEV
         */
        const xCarouselContent = node.querySelector('x-carousel-content');
        if (xCarouselContent) {
          customElements.whenDefined('x-carousel-content').then(() => {
            requestAnimationFrame(() => {
              const shadowCarouselContent = xCarouselContent.shadowRoot;
              if (shadowCarouselContent) {
                const ul = shadowCarouselContent.querySelector('ul.x-carousel-content');
                if (ul && !ul.hasAttribute('role')) {
                  ul.setAttribute('role', 'list')
                }
              } else {
                console.warn('<x-carousel-content> has no open shadowRoot or hasn\'t rendered it yet');
              }
              const xCarouselItems = xCarouselContent.querySelectorAll('x-carousel-item');
              xCarouselItems.forEach((carouselItem) => {
                if (carouselItem) {
                  const xseProductCode = carouselItem.getAttribute('xse-prod-code');
                  const xseProductName = carouselItem.querySelector('section.xse-product-info span.xse-prod-name')?.textContent.trim();
                  const xseImageContainerSection = carouselItem.querySelector('section.xse-image-container');
                  const xseProductLabelContainerSection = carouselItem.querySelector('section.xse-product-label-container');
                  const xseProductInfoSection = carouselItem.querySelector('section.xse-product-info');
                  const xseProductTopSection = carouselItem.querySelector('section.xse-product-top');
                  const xsePriceContainerSection = carouselItem.querySelector('section.xse-price-container');

                  if (xseImageContainerSection && !xseImageContainerSection.getAttribute('aria-label')) {
                    xseImageContainerSection.setAttribute('aria-label', `Product images for ${xseProductName}(${xseProductCode})`);
                  }

                  if (xseProductLabelContainerSection && !xseProductLabelContainerSection.getAttribute('aria-label')) {
                    xseProductLabelContainerSection.setAttribute('aria-label', `Product labels for ${xseProductName}(${xseProductCode})`);
                  }

                  if (xseProductInfoSection && !xseProductInfoSection.getAttribute('aria-label')) {
                    xseProductInfoSection.setAttribute('aria-label', `Product info for ${xseProductName}(${xseProductCode})`);
                  }

                  if (xseProductTopSection && !xseProductTopSection.getAttribute('aria-label')) {
                    xseProductTopSection.setAttribute('aria-label', `Product top for ${xseProductName}(${xseProductCode})`);
                  }

                  if (xsePriceContainerSection && !xsePriceContainerSection.getAttribute('aria-label')) {
                    xsePriceContainerSection.setAttribute('aria-label', `Product price for ${xseProductName}(${xseProductCode})`);
                  }
                }
                customElements.whenDefined('x-carousel-item').then(() => {
                  requestAnimationFrame(() => {
                    const shadowCarouselItem = carouselItem.shadowRoot;
                    if (shadowCarouselItem) {
                      const li = shadowCarouselItem.querySelector('li.x-carousel-item');
                      if (li && !li.hasAttribute('role')) {
                        li.setAttribute('role', 'listitem')
                      }
                    } else {
                      console.warn('<x-carousel-item> has no open shadowRoot or hasn\'t rendered it yet');
                    }
                  });
                });
              });
            })
          });
        }
        /**
         * END
         * Fix1: <ul> and <ol> must only directly contain <li>, <script> or <template> elements
         * Fix2: <li> elements must be contained in a <ul> or <ol>
         * Page: Product view
         * Accessibility Tool: AXEDEV
         */

        /**
         * START
         * Fix: Broken ARIA reference
         * Page: Rewards
         * Accessibility Tool: WAVE
         */
        const emailYotpoInput = node.querySelector('.yotpo-email-container input[name="email"]');
        if (emailYotpoInput) {
          const errorId = emailYotpoInput.getAttribute('aria-describedby');
          if (!emailYotpoInput.classList.contains('yotpo-field-error')) {
            const newElem = document.createElement('div');
            newElem.id = errorId;
            newElem.classList.add('sr-only');
            newElem.classList.add(`custom-${errorId}`);
            newElem.setAttribute('aria-hidden', 'true');
            emailYotpoInput.insertAdjacentElement('afterend', newElem);
          }

          // Start watching for class changes (e.g., when .yotpo-field-error is added/removed)
          const classObserver = new MutationObserver((attrMutations) => {
            attrMutations.forEach((attrMutation) => {
              if (attrMutation.type === 'attributes' && attrMutation.attributeName === 'class') {
                const customDiv = emailYotpoInput.parentElement.querySelector(`.custom-${errorId}`);
                if (emailYotpoInput.classList.contains('yotpo-field-error')) {
                  if (customDiv) customDiv.remove();
                } else {
                  if (!customDiv) {
                    const newElem = document.createElement('div');
                    newElem.id = errorId;
                    newElem.classList.add('sr-only');
                    newElem.classList.add(`custom-${errorId}`);
                    newElem.setAttribute('aria-hidden', 'true');
                    emailYotpoInput.insertAdjacentElement('afterend', newElem);
                  }
                }
              }
            });
          });

          classObserver.observe(emailYotpoInput, {
            attributes: true,
            attributeFilter: ['class']
          });
        }
        /**
         * END
         * Fix: Broken ARIA reference
         * Page: Rewards
         * Accessibility Tool: WAVE
         */

        /**
         * START
         * Fix: Spacer images missing alternative text
         * Page: All
         * Accessibility Tool: WAVE
        **/
        const spacerImage = node.matches('img[style*="display: none"]');
        if (spacerImage && !node.hasAttribute('alt')) {
          node.setAttribute('alt', '')
        }

        const spacerImages = node.querySelectorAll('img[style*="display: none"]');
        spacerImages.forEach(spacerImage => {
          if (!spacerImage.hasAttribute('alt')) {
            spacerImage.setAttribute('alt', '')
          }
        });
        /**
         * END
         * Fix: Spacer images missing alternative text
         * Page: All
         * Accessibility Tool: WAVE
        **/

        /**
         * START
         * Fix: <ul> and <ol> must only directly contain <li>, <script> or <template> elements
         * JIRA: B2CECOM-1544
         * Page: All
         * Accessibility Tool: Axedev
        **/
        const ul = document.querySelector('ul.nav-container.level-1');
        const anchors = Array.from(ul.childNodes).filter(node => node.nodeName === 'A');
        anchors.forEach(anchor => {
          const li = document.createElement('li');
          ul.insertBefore(li, anchor);
          li.appendChild(anchor);
        });
        /**
         * END
         * Fix: <ul> and <ol> must only directly contain <li>, <script> or <template> elements
         * JIRA: B2CECOM-1544
         * Page: All
         * Accessibility Tool: Axedev
        **/
      });
    });
  });

  // Start observing the DOM for dynamically added content
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /**
   * START
   * Fix: All page content should be contained by landmarks, Scrollable region must have keyboard access & Images must have alternative text
   * JIRA: B2CECOM-1544
   * Page: Product View
   * Accessibility Tool: Axedev
  **/
  waitForElement('div.kiwi-sizing-modal.modal-style-0', (kiwiSizingModalDiv) => {
    if (kiwiSizingModalDiv) {
      kiwiSizingModalDiv.setAttribute('tabIndex', 0);
      kiwiSizingModalDiv.setAttribute('role', 'dialog');
      kiwiSizingModalDiv.setAttribute('aria-label', 'Sizing Chart Modal');

      // Watch for changes in the modal content
      const observer = new MutationObserver((mutations) => {
        const ksImage = kiwiSizingModalDiv.querySelector('.ks-image > img');
        if (ksImage && !ksImage.hasAttribute('alt')) {
          ksImage.setAttribute('alt', 'Kiwisizing reference image for New Era Cap sizing visualization');
          observer.disconnect();
        }
      });

      observer.observe(kiwiSizingModalDiv, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'data-src']
      });
    }
  });

  waitForElement('div.ks-image > img', (ksImage) => {
    if (ksImage && !ksImage.hasAttribute('alt')) {
      ksImage.setAttribute('alt', 'Kiwisizing reference image for New Era Cap sizing visualization');
    }
  })

  /**
   * END
   * Fix: All page content should be contained by landmarks, Scrollable region must have keyboard access & Images must have alternative text
   * JIRA: B2CECOM-1544
   * Page: Product View
   * Accessibility Tool: Axedev
  **/

  /**
   * START
   * Fix: All page content should be contained by landmark
   * Page: Rewards
   * Accessibility Tool: AXEDEV
  **/
  waitForElements('div.XGen_SmartElement', (elements) => {
    elements.forEach((xGenSmartElement) => {
      if (xGenSmartElement) {
        const h2 = xGenSmartElement.querySelector(':scope > h2');
        const h2Text = h2 ? h2.textContent : '';
        xGenSmartElement.setAttribute('role', 'region');
        xGenSmartElement.setAttribute('aria-label', h2Text);
      }
    })
  })
  /**
   * END
   * Fix: All page content should be contained by landmark
   * Page: Rewards
   * Accessibility Tool: AXEDEV
  **/

  /**
   * START
   * Fix: Images must have alternative text
   * Page: Rewards
   * Accessibility Tool: AXEDEV
  **/
  waitForElements('img.yotpo-vip-tier-benefit-icon', (benefitImages) => {
    benefitImages.forEach((benefitImage) => {
      if (benefitImage) {
        benefitImage.setAttribute('alt', 'Included');
      }
    })
  })
  /**
   * END
   * Fix: Images must have alternative text
   * Page: Rewards
   * Accessibility Tool: AXEDEV
  **/

  /**
   * START
   * Fix: Spacer images missing alternative text
   * Page: All
   * Accessibility Tool: WAVE
  **/
  waitForElements('img[style*="display: none"]', function (spacerImages) {
      spacerImages.forEach(spacerImage => {
          if (!spacerImage.getAttribute('alt')) {
            spacerImage.setAttribute('alt', '');
          }
      })
  });
  /**
   * END
   * Fix: Spacer images missing alternative text
   * Page: All
   * Accessibility Tool: WAVE
  **/

  waitForElements('div.XGen_SmartElement', (xGenSmartElements) => {
    xGenSmartElements.forEach(xGenSmartElement => {
      const xseTitle = xGenSmartElement.querySelector('h2.xse-title');
      if (xseTitle) {
        const section = document.createElement('section');

        xseTitle.parentNode.insertBefore(section, xseTitle);
        section.appendChild(xseTitle)
      }
    })
  })
});

/**
 * Waits for an element to appear in the DOM before running a callback
 */
function waitForElement(selector, callback) {
  const interval = setInterval(() => {
    const el = document.querySelector(selector);
    if (el) {
      clearInterval(interval);
      callback(el);
    }
  }, 100);
}

/**
 * Waits for elements to appear in the DOM before running a callback
 */
function waitForElements(selector, callback) {
  const interval = setInterval(() => {
    const elements = document.querySelectorAll(selector);
    if (elements.length > 0) {
      clearInterval(interval);
      callback(elements);
    }
  }, 100);
}